import 'rxjs/Rx';

import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { MyCapitalActions } from './mycapital.action';
import { MyCapitalService } from '../../services/mycapital/mycapital.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MyCapitalEffects {
  constructor(
    private actions$: Actions<MyCapitalActions>,
    private myCapitalService: MyCapitalService,
    private toastr: ToastrService,
  ) {}

  @Effect()
  public getMyCapitalKeys$: Observable<any> = this.actions$
    .pipe(
      ofType(MyCapitalActions.getMyCapitalKeys),
      switchMap(() => this.myCapitalService.getMyCapitalKeys()),
      map((mycapital) => {
        return {
          type: MyCapitalActions.getMyCapitalKeysSuccess,
          payload: mycapital,
        };
      }),
    )
    .pipe(
      catchError((error) =>
        this.handlerToastError(
            MyCapitalActions.getMyCapitalKeysError,
          error,
        ),
      ),
      share(),
    );

  private handlerToastError(actionType: any, error: any) {
    this.toastr.error(`Ops! Ocorreu um erro, por favor tente mais tarde.`, '', {
      timeOut: 5000,
      progressBar: true,
      positionClass: 'toast-bottom-center',
      toastClass: 'toast--default font-small--medium font-light-color',
    });

    return of({ type: actionType, payload: error });
  }
}
